import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../../../types/store';

import {
  isCurrentUserProfileOwner,
  getProfileOwnerUser,
} from '../../../../../selectors/users';

import { Props } from './EmptyState';

type StateProps = Pick<Props, 'isOwner' | 'username'>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  isOwner: isCurrentUserProfileOwner(state),
  username: getProfileOwnerUser(state).username,
});

export default connect(mapStateToProps);
